import { Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { individualHideGachaRemainingItemCount } from '@/core/individual'
type Props = {
  disabled: boolean
  remainingLimitedItemCount: number
  totalLimitedItemCount: number
  isLimited: boolean
}
/**
 * @description
 * 限定ガチャの在庫数表示用コンポーネント
 */
export const RemainingItemCount = ({
  disabled,
  remainingLimitedItemCount,
  totalLimitedItemCount,
  isLimited,
}: Props) => {
  const { t } = useTranslation('gachaDetail')

  if (!isLimited || individualHideGachaRemainingItemCount()) return null

  const textColor = disabled
    ? 'text.hint'
    : remainingLimitedItemCount / totalLimitedItemCount < 0.2
    ? 'error.main'
    : 'text.primary'

  return (
    <Stack direction="row" sx={{ py: 2 }} justifyContent="flex-end" spacing={1}>
      <Typography variant="overline" color={textColor}>
        {t('remain', '残り')}
      </Typography>
      <Typography variant="overline" color={textColor}>
        {remainingLimitedItemCount} / {totalLimitedItemCount}
      </Typography>
      <Typography variant="overline" color={textColor}>
        {t('remainUnit', '個')}
      </Typography>
    </Stack>
  )
}
